import { Brain, Zap } from "lucide-react"

import { Button } from "@ui/button"
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@ui/tooltip"

interface AgentModeBadgeProps {
    state: boolean
    disabled?: boolean
    onChange: (value: boolean) => void
}
export function AgentModeBadge({ state, disabled = false, onChange }: Readonly<AgentModeBadgeProps>) {
    const handleIsThinkingChange = () => {
        onChange(!state)
    }

    return (
        <div>
            <TooltipProvider>
                <Tooltip>
                    <TooltipTrigger asChild>
                        <Button variant="icon" size="icon" onClick={handleIsThinkingChange} className={`${state ? "bg-gray-950 text-white hover:bg-gray-550 hover:text-white" : ""}`} disabled={disabled}>
                            {state ? <Brain /> : <Zap />}
                        </Button>
                    </TooltipTrigger>
                    <TooltipContent>
                        <p>{state ? "Reasoning" : "Basic"} Mode</p>
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    )
}
